import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Minutes east of UTC for `zone` at instant `at`.
 *
 * `at` is required — a zone's offset is not a constant (New York is −300 in
 * winter and −240 under DST), so a zone-only signature could only be tested
 * against the wall clock. Replaces the private `moment().tz(zone)._offset`
 * read; dayjs has no `_offset`.
 *
 * @param {string} zone IANA timezone id
 * @param {Date|string} at Instant the offset is taken at
 * @returns {number}
 */
export function utcOffsetMinutesFor(zone, at) {
  if (at == null || at === "") {
    throw new TypeError(
      "utcOffsetMinutesFor: `at` (Date or ISO string) is required"
    );
  }
  return dayjs(at).tz(zone).utcOffset();
}
